import { Component } from '@angular/core';

@Component({
    selector: 'app-web-view',
    template: ''
})
export class WebViewComponent {

}



// WEBPACK FOOTER //
// ./src/app/views/devices/web-view/web-view.component.ts